/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Belge_Bolum_BaslikInputs */

const tr_belge_bolum_baslik = /** @type {(inputs: Belge_Bolum_BaslikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alıcı ve Sipariş Bilgileri`)
};

const en_belge_bolum_baslik = /** @type {(inputs: Belge_Bolum_BaslikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer and Order Details`)
};

const de_belge_bolum_baslik = /** @type {(inputs: Belge_Bolum_BaslikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angaben zu Käufer und Bestellung`)
};

const ru_belge_bolum_baslik = /** @type {(inputs: Belge_Bolum_BaslikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сведения о покупателе и заказе`)
};

/**
* | output |
* | --- |
* | "Buyer and Order Details" |
*
* @param {Belge_Bolum_BaslikInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const belge_bolum_baslik = /** @type {((inputs?: Belge_Bolum_BaslikInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Belge_Bolum_BaslikInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_belge_bolum_baslik(inputs)
	if (locale === "de") return de_belge_bolum_baslik(inputs)
	if (locale === "ru") return ru_belge_bolum_baslik(inputs)
	return tr_belge_bolum_baslik(inputs)
});